import { ResolveTenantOptions } from './types';

export const DEFAULT_TENANT_KEY = 'zazmic';

export const HOSTNAME_TENANT_MAP: Record<string, string> = {
  localhost: DEFAULT_TENANT_KEY,
  '127.0.0.1': DEFAULT_TENANT_KEY,
  'aquazeel.localhost': 'aquazeel',
  'zazmic.localhost': 'zazmic',
  'aconnect.aquazeel.com': 'aquazeel',
  'stg.aconnect.aquazeel.com': 'aquazeel',
  'portal.zazmic.com': 'zazmic',
  'stg.portal.zazmic.com': 'zazmic',
};

export const normalizeTenantKey = (value?: string | null) => {
  if (!value) {
    return '';
  }

  return value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
};

const getTenantFromQueryParam = (search: string) => {
  const params = new URLSearchParams(search);
  return normalizeTenantKey(params.get('tenant'));
};

const getTenantFromHostname = (hostname: string) => {
  const normalizedHostname = hostname.trim().toLowerCase();

  if (!normalizedHostname) {
    return DEFAULT_TENANT_KEY;
  }

  if (HOSTNAME_TENANT_MAP[normalizedHostname]) {
    return HOSTNAME_TENANT_MAP[normalizedHostname];
  }

  if (
    normalizedHostname === 'localhost' ||
    normalizedHostname === '127.0.0.1'
  ) {
    return DEFAULT_TENANT_KEY;
  }

  if (normalizedHostname.endsWith('.aquazeel.com')) {
    return 'aquazeel';
  }

  if (normalizedHostname.endsWith('.zazmic.com')) {
    return 'zazmic';
  }

  const [subdomain] = normalizedHostname.split('.');

  if (!subdomain || subdomain === 'www' || subdomain === 'app') {
    return DEFAULT_TENANT_KEY;
  }

  return normalizeTenantKey(subdomain) || DEFAULT_TENANT_KEY;
};

export const resolveTenantFromHostname = (
  options: ResolveTenantOptions = {}
) => {
  const hostname = options.hostname ?? window.location.hostname;
  const search = options.search ?? window.location.search;
  const isDevelopment =
    options.isDevelopment ?? process.env.NODE_ENV === 'development';

  if (isDevelopment) {
    const queryTenant = getTenantFromQueryParam(search);

    if (queryTenant) {
      return queryTenant;
    }
  }

  return getTenantFromHostname(hostname);
};
